import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {RiWhatsappLine} from 'react-icons/ri'
import { useRef } from 'react';
import emailjs, { sendForm } from 'emailjs-com'

const Contact = () => {
  const form = useRef();
  
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_hkij7vt', 'template_h7kpduf', form.current, 'o12s5RCu5frhOZBVR')

    e.target.reset()
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      
      <div className="container contact__container">
        <div className="contact__options">
          <artical className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>msewwandi714@gmail.com</h5>
            <a href="mailto:msewwandi714@gmail.com" target="_blank">send a message</a>    
          </artical>

          <artical className="contact__option">
          <RiMessengerLine className='contact__option-icon'/>
            <h4>Messenger</h4>
            <h5>Sewwandi</h5>
            <a href="https://m.me/sewwandi.maheshika.92" target="_blank">send a message</a>    
          </artical>

          <artical className="contact__option">
          <RiWhatsappLine className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h3>+94702058802</h3>
            <a href="https://api.whatsapp.com/send?phone+94702058802" target="_blank">send a message</a>    
          </artical>
          
        </div>
        {/* END OF CONTACT OPTION */}

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message"  rows="7" placeholder='Your Messsage' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact